import React, { PureComponent } from 'react';
import i18n from '../../../i18n';
import AnalysisCard from 'wt-react/dist/components/AnalysisCard/AnalysisCard';
import './Info.css';

class Info extends PureComponent {

  renderInfoText() {
    return (
      <React.Fragment>
        <AnalysisCard
          idOfCard='asd-comp-text'
          topOfAppId=''
          key={'info-text-card'}
          chartType='infotext'
          cardTitle='Important Information'
          //footnoteText=''
          //showDetailsOnHover={true}
          heroTitle='* SUBJECT TO CHANGE.</span>'
          infoText={'<span style="font-size:14px; margin-top: 20px; margin-bottom: 20px; color: #212529; font-weight: 400; line-height:1.15em;">WisdomTree may perform an optimization on your most recent portfolio to identify potential Wisdomtree Model Portfolios that have higher risk-adjusted returns (as measured by the Sharpe Ratio) than your original portfolio.<br /><br /></span><span style="font-size:14px; line-height:1.5em; font-style:italic">' + i18n.t('key-metrics-footnote') + '<br /><br />' + i18n.t('hypothetical-growth-footnote') + '</span>'}
        />
      </React.Fragment>
    )
  }

  render() {
    return (
      <div>
        <div className='row'>
          <div className='col-lg-12'>
            {this.renderInfoText()}
          </div>
        </div>
      </div>
    );
  }
}

export default Info;
